<script lang="ts">
  import { opdsStore } from '../stores/opds.svelte';
  import OPDSCatalogList from './OPDSCatalogList.svelte';
  import OPDSFeedBrowser from './OPDSFeedBrowser.svelte';

  const { currentFeed } = $derived(opdsStore);
</script>

<div class="opds-browser">
  {#if currentFeed}
    <OPDSFeedBrowser />
  {:else}
    <OPDSCatalogList />
  {/if}
</div>

<style>
  .opds-browser {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
</style>
